import { SvgIcon, SvgIconOwnProps } from '@mui/material';

export const InsuranceIcon = (props: SvgIconOwnProps): React.ReactElement => (
  <SvgIcon viewBox="0 0 24 24" {...props}>
    <mask
      id="insurance-icon-mask"
      style={{ maskType: 'alpha' }}
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="24"
      height="24"
    >
      <rect width="24" height="24" fill="#D9D9D9" />
    </mask>
    <g mask="url(#insurance-icon-mask)">
      <path d="M12 16C13.7 14.4667 14.7917 13.3875 15.275 12.7625C15.7583 12.1375 16 11.5167 16 10.9C16 10.3 15.7833 9.78333 15.35 9.35C14.9167 8.91667 14.4 8.7 13.8 8.7C13.45 8.7 13.1125 8.77083 12.7875 8.9125C12.4625 9.05417 12.2 9.25 12 9.5C11.8 9.25 11.5417 9.05417 11.225 8.9125C10.9083 8.77083 10.5667 8.7 10.2 8.7C9.6 8.7 9.08333 8.91667 8.65 9.35C8.21667 9.78333 8 10.3 8 10.9C8 11.2167 8.04167 11.5083 8.125 11.775C8.20833 12.0417 8.39167 12.3542 8.675 12.7125C8.95833 13.0708 9.3625 13.5083 9.8875 14.025C10.4125 14.5417 11.1167 15.2 12 16ZM12 22C9.68333 21.4167 7.77083 20.0875 6.2625 18.0125C4.75417 15.9375 4 13.6333 4 11.1V5L12 2L20 5V11.1C20 13.6333 19.2458 15.9375 17.7375 18.0125C16.2292 20.0875 14.3167 21.4167 12 22ZM12 19.9C13.7333 19.35 15.1667 18.25 16.3 16.6C17.4333 14.95 18 13.1167 18 11.1V6.375L12 4.125L6 6.375V11.1C6 13.1167 6.56667 14.95 7.7 16.6C8.83333 18.25 10.2667 19.35 12 19.9Z" />
    </g>
  </SvgIcon>
);
